// // client/src/components/auth/ResetPassword.jsx
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useParams, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import AppFooter from '../AppFooter';
// import { FaTimes } from 'react-icons/fa';

// export default function ResetPassword() {
//   const { token, tenant } = useParams();
//   const navigate = useNavigate();
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const [valid, setValid] = useState(false);
//   const [checking, setChecking] = useState(true);
//   const [busy, setBusy] = useState(false);
//   const [password, setPassword] = useState('');
//   const [confirm, setConfirm] = useState('');

//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       try {
//         const { data } = await axios.get(`${baseUrl}/api/users/password-reset/${token}`);
//         if (mounted) setValid(Boolean(data?.valid));
//       } catch {
//         if (mounted) setValid(false);
//       } finally {
//         if (mounted) setChecking(false);
//       }
//     })();
//     return () => { mounted = false; };
//   }, [baseUrl, token]);

//   const submit = async (e) => {
//     e.preventDefault();
//     if (!password || password.length < 8) {
//       toast.error('Password must be at least 8 characters.');
//       return;
//     }
//     if (password !== confirm) {
//       toast.error('Passwords do not match.');
//       return;
//     }
//     setBusy(true);
//     try {
//       const { data } = await axios.post(`${baseUrl}/api/users/password-reset/${token}`, { password });
//       toast.success(data?.message || 'Password updated. Please log in.');
//       navigate(tenant ? `/${tenant}/login` : '/login');
//     } catch (err) {
//       const msg = err?.response?.data?.message || 'Reset link is invalid or expired.';
//       toast.error(msg);
//     } finally {
//       setBusy(false);
//     }
//   };

//   if (checking) return <div className="p-4">Checking reset link…</div>;
//   if (!valid) return <div className="p-4">This reset link is invalid or expired.</div>;

//   return (
//     <div className="max-w-md mx-auto p-4">
//       <h2 className="hdr hdr--primary hdr--lg">Choose a new password</h2>
//       <form onSubmit={submit} className="space-y-4">
//         <input
//           type="password"
//           placeholder="New password (min 8 chars)"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           className="w-full border p-2"
//           required
//           minLength={8}
//           autoFocus
//         />
//         <input
//           type="password"
//           placeholder="Confirm new password"
//           value={confirm}
//           onChange={(e) => setConfirm(e.target.value)}
//           className="w-full border p-2"
//           required
//           minLength={8}
//         />
//         <button type="submit" disabled={busy} className="btn btn-primary text-white px-4 py-2 rounded">
//           {busy ? 'Updating…' : 'Update Password'}
//         </button>
//       </form>

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaTimes />,
//             label: 'Cancel',
//             onClick: () => navigate(tenant ? `/${tenant}/login` : '/login'),
//           },
//         ]}
//       />
//     </div>
//   );
// }


// client/src/components/auth/ResetPassword.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppFooter from '../AppFooter';
import { FaTimes, FaHome, FaArrowLeft } from 'react-icons/fa';
import PasswordInput from '../shared/PasswordInput';

export default function ResetPassword() {
  // const { token, tenant } = useParams();
  const { token: tokenParam, tenant } = useParams();
  const { search } = useLocation();
  const token = tokenParam || new URLSearchParams(search).get('token') || '';
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const [valid, setValid] = useState(false);
  const [checking, setChecking] = useState(true);
  const [busy, setBusy] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  // â­ New: Password match validation state
  const [passwordError, setPasswordError] = useState('');

  /**
   * Fallback helper to try multiple API endpoints
   * First tries /api/users/path, then falls back to /api/path
   */
  const getWithFallback = async (path) => {
    const urls = [`${baseUrl}/api/users${path}`, `${baseUrl}/api${path}`];
    let lastErr;
    for (const url of urls) {
      try {
        return await axios.get(url);
      } catch (e) {
        lastErr = e;
        if (e?.response?.status !== 404) throw e;
      }
    }
    throw lastErr;
  };

  /**
   * Fallback helper to try multiple API endpoints for POST requests
   * First tries /api/users/path, then falls back to /api/path
   */
  const postWithFallback = async (path, body) => {
    const urls = [`${baseUrl}/api/users${path}`, `${baseUrl}/api${path}`];
    let lastErr;
    for (const url of urls) {
      try {
        return await axios.post(url, body);
      } catch (e) {
        lastErr = e;
        if (e?.response?.status !== 404) throw e;
      }
    }
    throw lastErr;
  };

  /**
   * â­ New: Validate password confirmation in real-time
   * This provides immediate feedback to the user as they type
   */
  const validatePasswordMatch = (pass, conf) => {
    if (conf && pass !== conf) {
      setPasswordError('Passwords do not match');
      return false;
    } else {
      setPasswordError('');
      return true;
    }
  };

  /**
   * â­ Updated: Handle password change with validation
   */
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    // Validate against confirmation if it exists
    if (confirm) {
      validatePasswordMatch(newPassword, confirm);
    }
  };

  /**
   * â­ Updated: Handle confirm password change with validation
   */
  const handleConfirmPasswordChange = (e) => {
    const newConfirm = e.target.value;
    setConfirm(newConfirm);
    validatePasswordMatch(password, newConfirm);
  };

  /**
   * Check if the reset token is valid on component mount
   */
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await getWithFallback(`/password-reset/${token}`);
        if (mounted) setValid(Boolean(data?.valid));
      } catch {
        if (mounted) setValid(false);
      } finally {
        if (mounted) setChecking(false);
      }
    })();
    return () => { mounted = false; };
  }, [baseUrl, token]);

  /**
   * Handle form submission to reset password
   * â­ Updated: Enhanced validation with password confirmation
   */
  const submit = async (e) => {
    e.preventDefault();
    
    // â­ Validate minimum password length
    if (!password || password.length < 8) {
      toast.error('Password must be at least 8 characters.');
      return;
    }
    
    // â­ Validate password confirmation match
    if (password !== confirm) {
      setPasswordError('Passwords do not match');
      toast.error('Passwords do not match. Please ensure both fields are identical.');
      return;
    }
    
    setBusy(true);
    try {
      const { data } = await postWithFallback(`/password-reset/${token}`, { password });
      toast.success(data?.message || 'Password updated. Please log in.');
      navigate(tenant ? `/${tenant}/login` : '/login');
    } catch (err) {
      const msg = err?.response?.data?.message || 'Reset link is invalid or expired.';
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  /**
   * Get tenant ID from params or localStorage
   */
  const getTenantId = () =>
    Number(tenant) || Number(localStorage.getItem('tenantId')) || 1;

  /**
   * Navigate to dashboard
   */
  const handleDashboard = () => navigate(`/${getTenantId()}/dashboard`);

  // Show loading state while checking token validity
  if (checking) return <div className="p-4">Checking reset link…</div>;
  
  // Show error if token is invalid
  if (!valid) return <div className="p-4">This reset link is invalid or expired.</div>;

  return (
    <div className="max-w-md mx-auto p-4" style={{ paddingTop: '80px', paddingBottom: '120px' }}>
      <h2 className="hdr hdr--primary hdr--lg">Choose a new password</h2>
      <form onSubmit={submit} className="space-y-4">
        <div className="form-group">
          <PasswordInput
            placeholder="New password (min 8 chars)"
            value={password}
            onChange={handlePasswordChange}
            className="w-full border p-2"
            required
            minLength={8}
            autoFocus
          />
          {/* â­ New: Show password requirements hint */}
          <small className="form-text text-muted">
            Password must be at least 8 characters long
          </small>
        </div>
        
        {/* â­ Updated: Enhanced confirmation field with validation feedback */}
        <div className="form-group">
          <PasswordInput
            placeholder="Confirm new password"
            value={confirm}
            onChange={handleConfirmPasswordChange}
            className={`w-full border p-2 ${passwordError ? 'border-red-500' : ''}`}
            required
            minLength={8}
          />
          {/* â­ New: Display password match error in real-time */}
          {passwordError && (
            <small className="form-text text-danger d-block mt-1">
              {passwordError}
            </small>
          )}
          {/* â­ New: Display success indicator when passwords match */}
          {confirm && !passwordError && password === confirm && (
            <small className="form-text text-success d-block mt-1">
              ✓ Passwords match
            </small>
          )}
        </div>
        
        <button 
          type="submit" 
          disabled={busy || password !== confirm || passwordError || !password} 
          className="btn btn-primary text-white px-4 py-2 rounded"
        >
          {busy ? 'Updating…' : 'Update Password'}
        </button>
      </form>

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { 
            icon: <FaHome />, 
            label: 'Cancel', 
            onClick: handleDashboard 
          }
        ]}
      />
    </div>
  );
}